import React from 'react'
import PropTypes from 'prop-types'

import { Box, Flex } from '@chatterbug/aaron'

const SearchHeaderSkeleton = ({ nameSection, inputSection }) => {
  return (
    <Flex flexDirection="column">
      <Box as="h1" variant="text.h3">
        {nameSection}
      </Box>
      <Box mt="2x">{inputSection}</Box>
    </Flex>
  )
}

SearchHeaderSkeleton.propTypes = {
  nameSection: PropTypes.any.isRequired,
  inputSection: PropTypes.any.isRequired,
}

export default SearchHeaderSkeleton
